import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class AllApplicationsSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.canAccessAll = false;
        this.allowVendorHierarchySearch = false;
        this.applicationStatusList = [];
        this.documentStatusList = [];
        this.salepersons = [];
        this.shouldShowCarSearchFields = false;
        this.hideAllTasksSignedExceptType = false;
        this.hideRegnrFieldInTable = false;
        this.hideDocumentStatusFilter = false;
        this.enableExternalOfferNumberSearch = false;
    }
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
    static async fetch(input, init) {
        const data = await super.fetch(input, init);
        return data.initialData;
    }
}
AllApplicationsSettingsResource.urlRoot = legacyApiResourceUrl("AllApplications/Vulcan");
//# sourceMappingURL=AllApplicationsSettingsResource.js.map